import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import state from './state';

/**
 * Método para agendar un informe de control de accesos
 *
 * @export
 * @param {*} {state, commit}
 */
export async function agendarInforme({state, commit}, data) { 
    await $http.post('/empresas/procesamientos_background/REGISTROS-ACCESOS', data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 6000})
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors + '<br> ' + error.message,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

export async function listarInformesAgendados({state, commit}) {
    await $http.get('empresas/procesamientos_background/REGISTROS-ACCESOS')
        .then((response) => {
           commit('setInformesProcesados', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000})
        })
}

export async function descargarInforme({ commit, state }, id) {
    await $http.post(`empresas/procesamientos_background/REGISTROS-ACCESOS/${id}`)
        .then((response) => {
            commit('setInforme', response.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: false,
                timer: 2000})
            state.error = true;
        })
}

/**
 * Método para descargar el inventario de productos químicos.
 *
 * @param {*} param0
 * @param {*} id id del agendamiento 
 */
 export async function descargarInventario({ commit, state }, id) {
    await $http.post(`empresas/procesamientos_background/INVENTARIO-PRODUCTOS/${id}`)
        .then((response) => {
            commit('setInventario', response.data);
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: false,
                timer: 2000})
            state.error = true;
        })
}